import React, { useContext, useRef } from 'react';
import ChartElements from './ChartElements';
import FiltersContainer from './FiltersContainer';
import styled, {css} from 'styled-components'
import { DragDropContext } from 'react-beautiful-dnd';
import { ChartContext } from '../context/ChartContext'
import _ from 'lodash'
// import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

const MainChartContainerDiv = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-area: content;
    grid-column-gap: 10rem;
    ${'' /* border: 1px solid #333; */}
    position: relative;

    margin-top: 2.5rem;
`

const FiltersContainerMain = styled.div`
    
    display: grid;
    grid-row: 1;
    grid-column: 1;
    grid-template-rows: 25rem 10rem 50rem;
    align-self: stretch;
    ${'' /* border: 1px solid #333; */}
    visibility: visible;
    padding-left: 1rem;

    ${props => props.hideFilters && css`
        visibility: hidden;
        transition-delay: .5s;
   `}
`

const ChartContainer = styled.div`
    height: 100%;
    position: absolute;
    top:0;
    right: 0;
    width: calc(50% - 5rem);
    z-index: 1000;
    background-color: #fff;
    transition: all .5s ease-in-out; 
    padding-left: 1rem;

    ${props => props.hideFilters && css`
            width: 100%;
    `}
`

const MainChartContainer = () => {

    const { setBorderDroppable,
            metricQuestions,  setMetricQuestions,
            filterQuestions, setFiltersQuestions,
            chartQuestions, setChartQuestions, mainData,
            hideFilters } = useContext(ChartContext)

    const containerRef = useRef()

    // const disableBody = target => disableBodyScroll(target);
    // const enableBody = target => enableBodyScroll(target);

    const onDragEnd = result => {
        const { destination, source, draggableId } = result
        setBorderDroppable(false)
        // enableBody(containerRef.current)
        if(!destination){return}
 
        if (
            destination.droppableId === source.droppableId
        ){
            return
        }

        const updateMetricQuestions = () => {
            const newMetricQuestions = _.uniqBy(metricQuestions.filter(d => +d.qid !== draggableId), "qid")
            setMetricQuestions([...newMetricQuestions])
        }

        if (
            destination.droppableId === 2
        ) {
            const filterQuestion = mainData.filter(d => +d.qid === draggableId)[0]
            updateMetricQuestions()
            setFiltersQuestions([...filterQuestions, filterQuestion])
        } else if (
            destination.droppableId === 3
        ) {
            const chartQuestion = mainData.filter(d => +d.qid === draggableId)[0]
            updateMetricQuestions()
            setChartQuestions([...chartQuestions, chartQuestion])
        }        
    }

    const onDragStart = () => {
        setBorderDroppable(true)
    }

    return ( 
        <>
            <DragDropContext
                onDragStart={onDragStart}
                onDragEnd={onDragEnd}
            >
                <MainChartContainerDiv
                    ref={containerRef}
                >
                    <FiltersContainerMain
                        hideFilters={hideFilters}
                    >
                        <FiltersContainer/>
                    </FiltersContainerMain>
                    <ChartContainer
                        hideFilters={hideFilters}
                    >
                        <ChartElements/>
                    </ChartContainer>
                </MainChartContainerDiv>
            </DragDropContext>
        </>
     );
}
 
export default MainChartContainer;